<template>
	<v-navigation-drawer
		:value="open"
		fixed
		temporary
		class="main-app-nav-bar"
		v-if="showAdminMenu"
		width="350"
		:style="{ marginTop: marginTop + 'px', height: `calc(100% - ${marginTop}px)` }"
		@input="stateChanged"
	>
		<v-list>
			<div
				v-for="(menuSection, sectionIndex) in menu"
				:class="{ 'main-app-nav-bar-section': sectionIndex !== 0 && sectionIndex !== menu.length - 1 }">
				<template v-for="parent in menuSection">
					<v-list-group
						v-if="parent.children && parent.children.length > 0"
						:prepend-icon="parent.icon"
						:key="parent.title"
						append-icon=""
						active-class="active-group"
					>
						<template v-slot:activator>
							<v-list-tile>
								<v-list-tile-content>
									<v-list-tile-title>{{ parent.title }}</v-list-tile-title>
								</v-list-tile-content>
							</v-list-tile>
						</template>
						<v-list-tile
							v-for="child in parent.children"
							:key="child.title"
							:to="child.url"
							@click=""
							class="child-element"
							active-class="active-child"
						>
							<v-list-tile-content>
								<v-list-tile-title>{{ child.title }}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
					<v-list-tile
						v-else
						:key="parent.title"
						:to="parent.url"
						:class="{ 'home-element': parent.isHomeItem }"
						class="child-free-element"
						exact
						active-class="active-child-free-element"
					>
						<v-list-tile-action>
							<v-icon v-if="parent.icon" color="#2391de">{{ parent.icon }}</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>{{ parent.title }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</template>
			</div>

		</v-list>
	</v-navigation-drawer>
</template>
<script>
import appConfig from "../../appconfig";
import {mapGetters} from "vuex";

const tenantConfig = appConfig.tenantConfig;

export default {
	name: "NavBarAdmin",
	props: ["open", "marginTop"],
	data: () => ({
		useOverwrittenMenu: false,
		displayMealCounterPage: false,
		admins: [
			["Management", "people_outline"],
			["Settings", "settings"]
		],
		cruds: [
			["Create", "add"],
			["Read", "insert_drive_file"],
			["Update", "update"],
			["Delete", "delete"]
		]
	}),
	created() {
		this.displayMealCounterPage = this.featureToggles.displayMealCounterPage;
		this.$store.dispatch("setNavMenuItems", this.menu
			.flatMap(item => item)
			.flatMap(parent =>
				parent.children ?
					parent.children.map(child => ({icon: parent.icon, ...child})) :
					parent
			)
		);
	},
	computed: {
		...mapGetters(["adminDetails", "jwtToken", "productCatalog", "productEditingState", "envPrefix", "featureToggles", "languages", "lastLocaleAdmin", "isNavBarOpen"]),
		showAdminMenu() {
			const self = this;
			if (self.envPrefix === "p" || self.envPrefix === "o") {
				if (appConfig.isBetaMode()) {
					self.useOverwrittenMenu = false;
					return true;
				} else if (!appConfig.isBetaMode() && self.overwrittenMenu.length > 0) {
					self.useOverwrittenMenu = true;
					return true;
				} else {
					self.useOverwrittenMenu = false;
					return false;
				}
			} else {
				self.useOverwrittenMenu = false;
				return true;
			}
		},
		menu() {
			const self = this;
			let menuItems = [
				[
					{
						title: "Home",
						icon: "home",
						url: "/admin/",
						isHomeItem: true
					}
				],
				[
					{
						title: "Products",
						icon: "inventory_2",
						children: [
							{
								title: "Catalog pages",
								url: "/admin/catalogPages",
								pagePermission: "catalogPagesOverviewPagePermission"
							},
							{
								title: "Catalog pages UI",
								url: "/admin/catalogPagesUI",
								pagePermission: "catalogPagesUIOverviewPagePermission"
							},
							{
								title: "Products",
								url: "/admin/products",
								pagePermission: "productOverviewPagePermission"
							},
							{
								title: "Product ingredients",
								url: "/admin/productsIngredients",
								pagePermission: "createProductIngredientsPagePermission"
							}
							// {
							// 	title: "Enriched product catalogs",
							// 	url: "/admin/enrichedCatalog",
							// 	pagePermission: "enrichedProductCatalogsPagePermission"
							// }
						]
					},
					{
						title: "Shops",
						icon: "shopping_cart",
						children: [
							// {
							// 	title: "Shops",
							// 	url: "/admin/shops/",
							// 	pagePermission: "shopsSettingsPagePermission"
							// },
							// {
							// 	title: "Opening hours per shop",
							// 	url: "/admin/timePicker/",
							// 	pagePermission: "timePickerPagePermission"
							// },
							{
								title: "Quick ordering",
								url: "/admin/newOrder",
								bothMenuAppearance: true,
								pagePermission: "newOrderPagePermission"
							},
							// {
							// 	title: "Localization settings",
							// 	url: "/admin/localizationSettings",
							// 	pagePermission: "localizationSettingsPagePermission"
							// },
							{
								title: "Shop Info",
								url: "/admin/shopInfo/",
								pagePermission: "shopInfoPagePermission"
							}
						]
					},
					{
						title: "Rules",
						icon: "grading",
						children: [
							{
								title: "Pickup datetime rules",
								url: "/admin/pickupRules",
								pagePermission: "pickupDateTimeRulesPagePermission"
							},
							{
								title: "Price rules",
								url: "/admin/priceRules",
								pagePermission: "priceRulesPagePermission"
							},
							{
								title: "Punch-card rules",
								url: "/admin/punchCardRules",
								pagePermission: "punchCardRulesPagePermission"
							},
							// {
							// 	title: "Cross-sell rules",
							// 	url: "/admin/crossSellRules",
							// 	pagePermission: "crossSellRulesPagePermission"
							// },
							{
								title: "Vouchers",
								url: "/admin/voucherRules",
								pagePermission: "vouchersPagePermission"
							},
							{
								title: "Capacity prototype",
								url: "/admin/capacityPrototype",
								pagePermission: "capacityRulesPrototypePagePermission"
							},
							// {
							// 	title: "Capacity rules",
							// 	url: "/admin/capacityRulesNew",
							// 	pagePermission: "capacityRulesPagePermission"
							// },
							{
								title: "Client redirects",
								url: "/admin/clientRedirects",
								pagePermission: "clientRedirectsPagePermission"
							},
							// {
							// 	title: "Obsolete",
							// 	url: "/admin/settings",
							// 	pagePermission: "settingsPagePermission"
							// },
							{
								title: "Terms & Conditions",
								url: "/admin/termsAndConditions",
								pagePermission: "termsAndConditionsPagePermission"
							}
						]
					}
				],
				[
					// {
					// 	title: "Protection",
					// 	icon: "verified_user",
					// 	children: [
					// 		{
					// 			title: "Subscriptions fraud protection",
					// 			url: "/admin/subscriptionsFraudProtection",
					// 			pagePermission: "subscriptionsFraudProtectionPagePermission"
					// 		}
					// 	]
					// },
					{
						title: "Control Panel",
						icon: "settings",
						children: [
							{
								title: "Order Control Panel ",
								url: "/admin/ordercontrolpanel/",
								pagePermission: "orderControlPanelPagePermission"
							},
							{
								title: "Developer support",
								url: "/admin/devsupport",
								pagePermission: "devSupportPagePermission"
							},
							{
								title: "Tenant Settings",
								url: "/admin/tenantSettings",
								pagePermission: "tenantSettingsPagePermission"
							},
							{
								title: "Feature toggle",
								url: "/admin/featureToggle",
								pagePermission: "featureTogglePagePagePermission"
							},
							{
								title: "Synchronizations",
								url: "/admin/synchronizations",
								pagePermission: "synchronizationsPagePermission"
							}
						]
					},
					{
						title: "Statistics",
						icon: "analytics",
						children: [
							{
								title: "Statistics",
								url: "/admin/statistics",
								pagePermission: "orderStatisticsPagePermission"
							},
							// {
							// 	title: "Order statistics",
							// 	url: "/admin/orderstatistics"
							// },
							{
								title: "Product statistics",
								url: "/admin/productstatistics",
								pagePermission: "productStatisticsPagePermission"
							},
							{
								title: "Export logs",
								url: "/admin/export",
								pagePermission: "exportPagePermission"
							},
							{
								title: "Product monitoring - Bager",
								url: "/admin/productMonitoring4/",
								pagePermission: "productMonitoring4PagePermission",
								showOnTenant: [2, 3]
							},
							{
								title: "Product monitoring - Juleaften",
								url: "/admin/productMonitoring3/",
								pagePermission: "productMonitoring3PagePermission",
								showOnTenant: [2, 3]
							},
							{
								title: "Product monitoring - Nytårsmenu",
								url: "/admin/productMonitoring/",
								pagePermission: "productMonitoringPagePermission",
								showOnTenant: [2, 3]
							},
							{
								title: "Product monitoring - Mortensaften",
								url: "/admin/productMonitoring2/",
								pagePermission: "productMonitoring2PagePermission",
								showOnTenant: [2, 3]
							},
							{
								title: "Product monitoring - Easter",
								url: "/admin/productMonitoring5/",
								pagePermission: "productMonitoring5PagePermission",
								showOnTenant: [2, 3]
							},
							...(self.displayMealCounterPage ?
								[{
									title: "Meal counter page",
									url: "/admin/productCounterOverview",
									pagePermission: "productCounterOverviewPagePermission"
								}] :
								[])
						]
					}
				]
				// {
				// 	title: "Ingredients",
				// 	url: "/admin/ingredients"
				// },

				//making this unaccessible via admin because the component isn't done
				//it will be finished after foodshop team is back from sunset
				//{
				//	title: "Generate Orders",
				//	url: "/admin/orders/generateOrders"
				//},
				// {
				// 	title: "S3 Cloud",
				// 	url: "/admin/s3Cloud"
				// }
			];

			// Check if item can be shown on tenant
			menuItems = menuItems.map(section => section.map(
				cat => {
					if (cat.children && cat.children.length > 0) {
						cat.children = cat.children.filter(
							el => el.showOnTenant ?
								el.showOnTenant.includes(tenantConfig.tenantId) : true
						);
						return cat;
					} else {
						return cat;
					}
				}));

			// Check if item is included in tenantConfig.adminMenuOverride
			if (self.useOverwrittenMenu && tenantConfig.adminMenuOverride) {
				menuItems = menuItems.map(section => section.map(
					cat => {
						if (cat.children && cat.children.length > 0) {
							cat.children = cat.children.filter(
								el => tenantConfig.adminMenuOverride.find(override => el.url === `/admin/${override}` || el.url === `/admin/${override}/`)
							);
							return cat;
						} else {
							return cat;
						}
					}));
			}

			// Check if item is disabled on the tenant
			if (tenantConfig.disabledAdminMenuPaths) {
				menuItems = menuItems.map(section => {
					const refactoredSection = section.map(cat => {
						if (cat.children && cat.children.length > 0) {
							cat.children = cat.children.filter(
								el => !tenantConfig.disabledAdminMenuPaths.find(override => el.url === `/admin/${override}` || el.url === `/admin/${override}/`)
							);
							return cat;
						} else {
							return cat;
						}
					});
					return refactoredSection;
				}
				);
			}

			const addToCategory = (categoryTitle, ...routeObjects) => {
				menuItems.forEach(section => {
					const category = section.find(category => category.title === categoryTitle);
					if (category) {
						category.children.push(...routeObjects);
					}
				});
			};

			if (self.featureToggles.marketingCards) {
				addToCategory("Control Panel", {
					title: "Marketing cards",
					url: "/admin/marketingCards",
					pagePermission: "marketingCardsPagePermission"
				},
				{
					title: "Target groups",
					url: "/admin/targetGroups",
					pagePermission: "targetingGroupsPagePermission"
				});
			}
			if(self.featureToggles.globalVersions){
				addToCategory("Control Panel", {
					title: "Global Versions GBO",
					url: "/admin/gbo/globalVersions",
					pagePermission: "globalVersionsGboPagePermission"
				});
			}
			return menuItems.filter(el => !el.showOnTenant || el.showOnTenant.includes(tenantConfig.tenantId));
		},
		overwrittenMenu() {
			const self = this;
			const menuItems = [];
			if (tenantConfig.adminMenuOverride) {
				tenantConfig.adminMenuOverride.forEach(override => {
					menuItems.push(self.menu.find(elem => {
						if (elem.url === `/admin/${override}` || elem.url === `/admin/${override}/`) {
							return elem;
						}
					}));
				});
			}
			return menuItems;
		},
		menuNonBetaMode() {
			return this.menu.filter(e => e.bothMenuAppearance);
		}
	},
	methods: {
		stateChanged(isOpen) {
			if (isOpen)
				this.$store.dispatch("openNavBar");
			else
				this.$store.dispatch("closeNavBar");
		}
	}
};
</script>
<style lang="scss">
.main-app-nav-bar {
	z-index: 999;
	background-color: #012a46 !important;
	padding: 0;
	box-shadow: unset !important;

	&-section {
		&:before, &:after {
			content: "";
			width: calc(100% - 66px);
			background-color: #80808054;
			height: 1px;
			position: absolute;
			left: 66px;
		}
	}

	.v-list__group .v-list__tile__title:hover {
		color: #90cffb !important;
	}

	.home-element {
		&:hover {
			.v-icon {
				color: #2391de !important;
				background-color: rgb(4, 77, 126);
				transition: background-color 200ms, color 200ms;
			}
		}

		.v-icon {
			background: #2591dc;
			border-radius: 20px;
			padding: 4px;
			margin-left: -4px;
			color: white !important;
		}
	}

	.child-free-element {
		.v-list__tile__title {
			color: white !important;
		}

		&:hover .v-list__tile__title {
			background-color: unset !important;
			color: #90cffb !important;
		}
	}

	.child-element .v-list__tile__title, .child-free-element .v-list__tile__title {
		height: 100%;
		display: flex;
		align-items: center;
		padding-left: 6px;
		color: white;
	}

	.active-child-free-element:before {
		margin-top: 0 !important;
	}

	.active-child-free-element:before, .active-group:before {
		content: "";
		position: absolute;
		height: 48px;
		width: 1px;
		background-color: #2391de;
		left: 65px;
		margin-top: -12px;
		transition: background-color 100ms ease-in-out;
	}

	.v-list__group--active:before, .v-list__group--active:after {
		background: unset !important;
	}

	.child-element {

		.active-child:before, &:hover:after {
			content: "";
			position: absolute;
			height: 48px;
			width: 1px;
			background-color: #2391de;
			left: 65px;
			margin-top: -48px;
			transition: background-color 100ms ease-in-out;
		}

		.active-child:before {
			margin-top: 0 !important;
		}

		&:hover .v-list__tile__title {
			background: #0444709e !important;
			color: white !important;
			transition: background-color 100ms ease-in-out, color 100ms ease-in-out;
		}

		.v-list__tile {
			padding-right: 0 !important;

			&__title {
				margin-left: 44px;
				padding-left: 18px;
				width: calc(100%);
				color: #90cffb !important;
			}
		}
	}


	.v-list {
		height: 100%;

		&:after {
			content: "";
			position: absolute;
			height: 100%;
			width: 1px;
			background-color: #80808054;
			left: 65px;
			top: 0;
		}

		&__tile {
			padding-left: 22px !important;
		}

		&__group {
			&__header {
				padding-left: 6px !important;
				color: white !important;

				.v-icon {
					color: #2391de !important;
				}
			}
		}
	}
}
</style>
